// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__gO5Re","Cards":"About_Cards__TH3pn"};